export const GeneralPMTasks = [
    {
        name: 'Weekly Team Meeting',
        cost: '200',
        grayAmount: '3',
        redAmount: '1',
        blueAmount: '0',
        earnedValue: '700',
        steps: '0',
        alert: 'Should be performed at least twice during the project',
        amountOfV: 0,
        beforeEnd: 2,
    },
    {
        name: 'Conduct Resource Control',
        cost: '100',
        grayAmount: '1',
        redAmount: '0',
        blueAmount: '0',
        earnedValue: '200',
        steps: '0',
        alert: 'Should be performed at every gate',
        amountOfV: 0,
        beforeEnd: -1,
    },
    {
        name: 'Conduct Schedule Control',
        cost: '200',
        grayAmount: '3',
        redAmount: '0',
        blueAmount: '0',
        earnedValue: '500',
        steps: '0',
        alert: 'Should be performed at every gate',
        amountOfV: 0,
        beforeEnd: -1,
    },
    {
        name: 'Conduct Cost Control',
        cost: '200',
        grayAmount: '3',
        redAmount: '1',
        blueAmount: '0',
        earnedValue: '700',
        steps: '0',
        alert: 'Should be performed at least twice during the project',
        amountOfV: 0,
        beforeEnd: 2,
    },
    {
        name: 'Manage Project Stakeholders',
        cost: '300',
        grayAmount: '0',
        redAmount: '1',
        blueAmount: '1',
        earnedValue: '1000',
        steps: '0',
        alert: 'Should be performed at least once during the project',
        amountOfV: 0,
        beforeEnd: 1,
    },
];
